import { encodeBase64 } from "effect/Encoding";
import { addEncodedIdToStruct } from "./utils";
import { Schema } from "effect";
const StatisticsFilterDate = Schema.Struct({
    id: Schema.Literal("date"),
    name: Schema.String,
    allowsMultiple: Schema.Boolean,
    options: Schema.Array(Schema.Struct({
        label: Schema.String,
        isDefault: Schema.Boolean,
        value: Schema.Struct({
            id: Schema.String,
            from: Schema.DateFromString,
            to: Schema.DateFromString
        })
    }).pipe((s)=>addEncodedIdToStruct(s, (x)=>encodeBase64(x.value.id))))
});
const StatisticsFilterEnv = Schema.Struct({
    id: Schema.Literal("environment"),
    name: Schema.String,
    allowsMultiple: Schema.Boolean,
    options: Schema.Array(Schema.Struct({
        label: Schema.String,
        value: Schema.String,
        isDefault: Schema.Boolean
    }).pipe((s)=>addEncodedIdToStruct(s, (x)=>encodeBase64(x.value))))
});
export const StatisticsFilterConfig = Schema.Struct({
    date: StatisticsFilterDate,
    environment: StatisticsFilterEnv
});
const StatisticsCurrency = Schema.Struct({
    type: Schema.Literal("currency"),
    value: Schema.Number
});
const StatisticsNumber = Schema.Struct({
    type: Schema.Literal("number"),
    value: Schema.Number
});
const StatisticsPercentage = Schema.Struct({
    type: Schema.Literal("percentage"),
    value: Schema.Number
});
const StatisticsValueError = Schema.Struct({
    type: Schema.Literal("error"),
    value: Schema.String
});
export const StatisticsValue = Schema.Union(StatisticsCurrency, StatisticsNumber, StatisticsPercentage, StatisticsValueError);
export const StatisticsValueAsProperties = Schema.Struct({
    currency: Schema.Number.pipe(Schema.optional),
    number: Schema.Number.pipe(Schema.optional),
    percentage: Schema.Number.pipe(Schema.optional),
    error: Schema.String.pipe(Schema.optional)
});
export const StatisticsValueFromProperties = Schema.transform(StatisticsValueAsProperties, StatisticsValue, {
    encode: (value)=>{
        const result = {};
        // @ts-expect-error
        result[value.type] = value.value;
        return result;
    },
    decode: (toEncode)=>{
        const [key, value] = Object.entries(toEncode)[0];
        return {
            type: key,
            value
        };
    },
    strict: true
});
